"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusAsignationInfo = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _index = require("../../atoms/ScreenHeader/index");

var _Avatar = require("../../atoms/Avatar");

var _index2 = require("../../atoms/Status/index");

var _GeneralButton = require("../../atoms/GeneralButton");

var _react = require("react");

var _index3 = require("../../atoms/AsignationOption/index");

var _data = require("../../../global-files/data");

var _SliderToolTip = require("../../atoms/SliderToolTip");

var _infoIcon = _interopRequireDefault(require("../../../assets/images/sliderToolTip/infoIcon.svg"));

var _slide = _interopRequireDefault(require("../../../assets/images/sliderToolTip/slide21.svg"));

var _slide2 = _interopRequireDefault(require("../../../assets/images/sliderToolTip/slide22.svg"));

var _slide3 = _interopRequireDefault(require("../../../assets/images/sliderToolTip/slide23.svg"));

var _FinancedCompanies = require("./FinancedCompanies");

var _jsxRuntime = require("react/jsx-runtime");

var StatusAsignationInfo = function StatusAsignationInfo(_ref) {
  var _assignationsImages$a, _assignationsImages$c;

  var _ref$status = _ref.status,
      status = _ref$status === void 0 ? "-" : _ref$status,
      imagesSection = _ref.imagesSection,
      setImageLayout = _ref.setImageLayout,
      _ref$percent = _ref.percent,
      percent = _ref$percent === void 0 ? 0 : _ref$percent,
      assignationsImages = _ref.assignationsImages,
      setAssignation = _ref.setAssignation,
      isRetailer = _ref.isRetailer,
      downloadImages = _ref.downloadImages,
      askToDeleteImages = _ref.askToDeleteImages,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "default-id" : _ref$id,
      onClickSave = _ref.onClickSave,
      showSaveButton = _ref.showSaveButton,
      canAssign = _ref.canAssign,
      version = _ref.version,
      setShowVersionSelector = _ref.setShowVersionSelector,
      user = _ref.user;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showAsignationPanel = _useState2[0],
      setShowAsignationPanel = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      layout = _useState4[0],
      setLayout = _useState4[1];

  var _useState5 = (0, _react.useState)("facilitator"),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      assignationType = _useState6[0],
      setAssignationType = _useState6[1];

  var isFinanced = _FinancedCompanies.FinancedCompanies.includes(user === null || user === void 0 ? void 0 : user.id_company);

  var closeAsignations = function closeAsignations(e) {
    if (!e.target.closest("#default-id") && showAsignationPanel) {
      document.removeEventListener("click", closeAsignations, false);
      setShowAsignationPanel(false);
    }
  };

  var slidefront = [{
    slide: _slide.default,
    title: "Valida tu producto en cada activo digital",
    description: "Al solicitar a Content-oh! podrás validar la información, imágenes y documentación de tu producto, esto hará más sencillo que puedas aprobar o rechazar el contenido."
  }, {
    slide: _slide2.default,
    title: "Aprueba o rechaza con un clic",
    description: "Cuando termines de revisar tu información, elige si aproebas o rechazas, esto enviara una notificiación a nuestro equipo, para continuar o corregir el producto."
  }, {
    slide: _slide3.default,
    title: "Estatus de tu producto en el proceso",
    description: "La mayor parte del proceso podrás identificar que estatus tiene tu producto, esto dara visibilidad a todo tu equipo para saber la etapa se encuentra."
  }];
  (0, _react.useEffect)(function () {
    if (showAsignationPanel) {
      document.addEventListener("click", closeAsignations, false);
    }
  }, [showAsignationPanel]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    id: id,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SliderToolTip.SliderToolTip, {
      infoIcon: _infoIcon.default,
      slidefront: slidefront,
      iconSize: "medium-image",
      slidePosition: "bottom-slide"
    }), version && /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
      buttonType: "general circular-button version-button",
      onClick: function onClick(e) {
        e.stopPropagation();
        e.preventDefault();
        setShowVersionSelector(true);
      },
      label: "V".concat(version)
    }), status !== "-" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index2.Status, {
      statusType: status,
      ovalForm: true
    }), showSaveButton && !isFinanced && /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
      buttonType: "circular-button save-button",
      onClick: onClickSave
    }), imagesSection && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "images-buttons",
      children: [showSaveButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
        buttonType: "circular-button delete-button",
        onClick: function onClick() {
          askToDeleteImages && askToDeleteImages();
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
        buttonType: "circular-button download-button",
        onClick: function onClick() {
          downloadImages();
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
        buttonType: layout ? "grid-layout" : "row-layout",
        onClick: function onClick() {
          setLayout(!layout);
          setImageLayout && setImageLayout(!layout);
        }
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "assignations-container",
      children: assignationsImages === null || assignationsImages === void 0 ? void 0 : (_assignationsImages$a = assignationsImages.assignations) === null || _assignationsImages$a === void 0 ? void 0 : _assignationsImages$a.map(function (assignation, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Avatar.Avatar, {
          imageType: "small-image",
          image: (0, _data.getProfilePicture)(assignation.id, 20, 20),
          altText: "user profile image",
          onClick: function onClick(e) {
            e.preventDefault();
            e.stopPropagation();
            setShowAsignationPanel(true);
            setAssignationType(assignation === null || assignation === void 0 ? void 0 : assignation.collaboratorType);
          }
        }, index + "-" + assignation.id);
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.ScreenHeader, {
      text: "Asig.",
      color: "#969696",
      fontFamily: "Avenir Next",
      headerType: "input-name-header"
    }), showAsignationPanel && canAssign && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "asignation-panel",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "asignation-header",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "asignation-status",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            children: "Estatus"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index2.Status, {
            statusType: status,
            ovalForm: true
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "asignation-percent",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            children: "Estatus"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
            className: "percent",
            children: [percent, "%"]
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "asignations-list",
        children: (assignationsImages === null || assignationsImages === void 0 ? void 0 : assignationsImages.collaborators) !== undefined ? assignationsImages === null || assignationsImages === void 0 ? void 0 : (_assignationsImages$c = assignationsImages.collaborators[assignationType]) === null || _assignationsImages$c === void 0 ? void 0 : _assignationsImages$c.map(function (asignation, index) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index3.AsignationOption, {
            profileImage: (0, _data.getProfilePicture)(asignation === null || asignation === void 0 ? void 0 : asignation.id_user, 40, 40),
            onClick: function onClick() {
              setAssignation(assignationType, asignation === null || asignation === void 0 ? void 0 : asignation.id_user);
            },
            name: asignation.name
          }, index + "-" + asignation.name);
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "no-asignations",
          children: "Sin personas para asignar"
        })
      }), isRetailer === 1 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "default-asignations-list",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_index3.AsignationOption, {
          asignationType: "provider",
          name: "Solicitar a",
          team: "Proveedor"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index3.AsignationOption, {
          asignationType: "team",
          name: "Solicitar a",
          team: "Content-oh!"
        })]
      })]
    })]
  });
};

exports.StatusAsignationInfo = StatusAsignationInfo;